import { RemoteAnnualRecovery } from '../../../data/usecases/annual-recovery/annual-recovery'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeRemoteAnnualRecovery = ():any => new RemoteAnnualRecovery('/configuracaorecuperacaoanual', makeAxiosHttpClient())

export const makeRemoteAnnualRecoveryItem = (id:number):any => new RemoteAnnualRecovery(`/configuracaorecuperacaoanual/${id}`, makeAxiosHttpClient())
